(function () {
  var root = document.querySelector('.mhs-refined-pdp');
  if (!root) return;
  var form = root.querySelector('.mhs-product-premium__form');
  if (!form) return;
  var queued = false;
  function compactPurchase() {
    var group = form.querySelector('.mhs-premium-cta-group');
    var widget = form.querySelector('.appstle_sub_widget');
    var quantity = form.querySelector('.mhs-product-premium__qty-row');
    var submit = form.querySelector('button[name="add"]');
    if (group && widget && quantity && submit && quantity.parentElement !== group) group.insertBefore(quantity, submit);
    var plan = form.querySelector('input[name="selling_plan"][value="1546518711"]');
    if (plan) {
      var option = plan.closest('.appstle_subscription_wrapper_option');
      if (option) {
        var text = form.dataset.mhsFourWeekLabel;
        var cadence = option.querySelector('.mhs-refined-cadence');
        if (!cadence) { cadence = document.createElement('p'); cadence.className = 'mhs-refined-cadence'; option.appendChild(cadence); }
        if (text && cadence.textContent !== text) cadence.textContent = text;
        option.querySelectorAll('.appstle_single_option_text, option[value="1546518711"]').forEach(function (label) {
          if (text && label.textContent !== text) label.textContent = text;
        });
      }
    }
  }
  compactPurchase();
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; compactPurchase(); });
  }).observe(form, { childList: true, subtree: true });
})();
